
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1159:534)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.54 11.242h-1.707v3.278h1.708v-3.278zm0 5.493a6.443 6.443 0 00-.623-.03c-.357 0-.711-.018-1.059-.036-1.331-.068-2.571-.131-3.538.843-1.218 1.23-1.903 4.01-1.903 5.748 0 1.739.684 4.179 1.903 5.408 1.147 1.157 2.679 1.153 4.292 1.148h.305c.209 0 .417-.01.624-.03v-13.05zm0 15.266h-1.707v3.277h1.708v-3.277zm-7.518-14.149l1.532-1.545-2.298-2.317-1.531 1.545 2.297 2.317zm-2.297 13.134l1.531 1.546v-.001l2.298-2.318-1.532-1.545-2.297 2.318zM14 22.168v2.185h3.25v-2.185H14z","fill":"#CCC"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1159:534","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1159:534"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1159:534","result":"shape"}})])])])
          )
        }
      }
    